import React, { useState } from "react"

const snippetOrigin =
  typeof window !== "undefined" && window.location.hostname === "shopshift.io"
    ? "https://cdn.shopshift.io"
    : window.location.origin

export default function ScriptTagBlock({ t, apiKey }) {
  const snippet = apiKey
    ? `<script src="${snippetOrigin}/s/${apiKey}.js" async></script>`
    : "<script>…</script>"

  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!apiKey) return
    try {
      await navigator.clipboard.writeText(snippet)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard API can fail (insecure context, denied permission). Silent.
    }
  }

  return (
    <div className="relative">
      <pre
        className="bg-surface-card border border-rule rounded-card p-4 pr-28 overflow-x-auto font-mono text-[12px] text-ink-primary"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {snippet}
      </pre>
      <button
        type="button"
        onClick={handleCopy}
        disabled={!apiKey}
        className="absolute top-2 right-2 px-3 py-1 text-[12px] font-medium rounded-button border border-rule bg-surface-card text-ink-primary hover:bg-surface-subtle disabled:opacity-50"
      >
        {copied ? t("dashboard.script.copied_feedback") : t("dashboard.script.copy_button")}
      </button>
    </div>
  )
}
